import { useState, useContext } from "react";

import { DUT_ACCORDION_SECTIONS } from "./constants";

import NewDutAccordionItem from "./NewDutAccordionItem";
import GeneralFindingsForm from "./forms/GeneralFindingsForm";
import FamilyHistoryForm from "./forms/FamilyHistoryForm";
import PersonalHistoryForm from "./forms/PersonalHistoryForm";
import AdmissionDetailsForm from "./forms/AdmissionDetailsForm";
import DiagnosisForm from "./forms/DiagnosisForm";
import TreatmentPlanForm from "./forms/TreatmentPlanForm";
import ImplantsForm from "./forms/ImplantsForm";
import InvestigationDocumentsForm from "./forms/InvestigationDocumentsForm";
import CareTeamDetailsForm from "./forms/CareTeamDetailsForm";
import STGQuestionnaireForm from "./forms/STGQuestionnaireForm";
import HospitalBillDetailsForm from "./forms/HospitalBillDetailsForm";
import ClaimQueryDetailsForm from "./forms/ClaimQueryDetailsForm";
import EnhancementTreatmentPlan from "./forms/AmountandIncentiveDetails";
import AmountandIncentiveDetails from "./forms/AmountandIncentiveDetails";
import { CaseStageContext } from "../dashboard/cases/contexts/CaseContexts";

const NewDutAccordion = ({ dutData, showAll, saveAll }) => {
  const { caseStage, setCaseStage } = useContext(CaseStageContext);
  const visibleSections = DUT_ACCORDION_SECTIONS.filter((section) => {
    if (
      section.id === "implants" &&
      (!dutData?.treatment?.implants || dutData.treatment.implants.length === 0)
    ) {
      return false;
    }

    return section?.caseStage
      ?.toLowerCase()
      ?.includes(caseStage?.toLowerCase());
  });
  const [expanded, setExpanded] = useState({
    "general-findings": true,
    "family-history": true,
    "personal-history": true,
    "admission-details": true,
    diagnosis: true,
    "treatment-plan": true,
    implants: true,
    "investigation-documents": true,
    "care-team-details": true,
    "stg-questionnaire": true,
    "Amount-and-Incentive-Details": true,
    "hospital-details": true,
    "claim-query-details": true,
    // "enhancement-investigation-documents": true,
  });

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpanded((prev) => ({
      ...prev,
      [panel]: isExpanded,
    }));
  };

  const renderAccordionContent = (id) => {
    switch (id) {
      case "general-findings":
        return (
          <GeneralFindingsForm
            data={dutData?.medicalInformation?.generalFindings}
            caseStage={"Admission"}
            saveAll={saveAll}
          />
        );

      case "family-history":
        return (
          <FamilyHistoryForm
            data={dutData?.medicalInformation?.familyHistory}
            caseStage={"Admission"}
            saveAll={saveAll}
          />
        );

      case "personal-history":
        return (
          <PersonalHistoryForm
            data={dutData?.medicalInformation?.personalHistory}
            caseStage={"Admission"}
            saveAll={saveAll}
          />
        );

      case "admission-details":
        return (
          <AdmissionDetailsForm
            data={dutData?.admissionInformation?.admissionDetails}
            caseStage={"Admission"}
            saveAll={saveAll}
          />
        );

      case "diagnosis":
        return (
          <DiagnosisForm
            data={dutData?.treatment?.diagnosis}
            caseStage={"Admission"}
          />
        );

      case "treatment-plan":
        return (
          <TreatmentPlanForm
            data={dutData?.treatment?.treatmentPlan}
            caseStage={"Admission"}
          />
        );

      case "implants":
        return <ImplantsForm data={dutData?.treatment?.implants} />;

      case "investigation-documents":
        return (
          <InvestigationDocumentsForm
            data={dutData?.treatment?.investigations}
            caseStage={"Admission"}
          />
        );

      case "care-team-details":
        return (
          <CareTeamDetailsForm data={dutData?.treatment?.careTeamDetails} />
        );

      case "hospital-details":
        return (
          <HospitalBillDetailsForm
            data={dutData?.finance?.hospitalBillDetails}
            caseStage={"Discharge"}
          />
        );

      case "claim-query-details":
        return <ClaimQueryDetailsForm />;

      case "Amount-and-Incentive-Details":
        return <AmountandIncentiveDetails />;

      // case "stg-questionnaire":
      //   return <STGQuestionnaireForm />;

      default:
        return null;
    }
  };

  return (
    <div className="w-full flex justify-center  min-h-screen pt-[7px] rounded-[16px]">
      <div className="w-full y 3xl:max-w-[1604px] flex flex-col gap-[8px] px-[16px] 3xl:px-[1px] py-[30px] rounded-[16px]">
        {" "}
        {visibleSections.map((section) => (
          <NewDutAccordionItem
            key={section.id}
            title={section.title}
            expanded={expanded[section.id] || showAll}
            onChange={handleAccordionChange(section.id)}
            wrapperClassName={
              section.id === "care-team-details" && expanded[section.id]
                ? "overflow-visible"
                : ""
            }
          >
            {renderAccordionContent(section.id)}
          </NewDutAccordionItem>
        ))}
      </div>
    </div>
  );
};

export default NewDutAccordion;
